<section class="ftp-services">

  <header class="ftp-header">
    <div>
      <h2 class="ftp-title">FTP Services</h2>
      <p class="ftp-subtitle">FTP and SFTP servers this organization can use.</p> <!--Saved passwords are never displayed or sent back to the browser.-->
    </div>
    <button mat-raised-button color="primary" type="button" (click)="addService()" [disabled]="loading">
      <mat-icon>add</mat-icon> Add FTP Service
    </button>
  </header>

  <!-- ================= LOADING ================= -->
  <div *ngIf="loading" class="state-panel">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Loading FTP services…</span>
  </div>

  <!-- ================= LOAD ERROR ================= -->
  <div *ngIf="!loading && loadError" class="state-panel error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ loadError }}</span>
    <button mat-stroked-button type="button" (click)="loadServices()">Retry</button>
  </div>

  <!-- ================= EMPTY ================= -->
  <div *ngIf="!loading && !loadError && services.length === 0" class="state-panel">
    <mat-icon class="empty-icon">dns</mat-icon>
    <span>No FTP services have been added yet.</span>
    <button mat-stroked-button color="primary" type="button" (click)="addService()">
      <mat-icon>add</mat-icon> Add your first FTP service
    </button>
  </div>

  <!-- ================= LIST ================= -->
  <table *ngIf="!loading && !loadError && services.length > 0"
         mat-table [dataSource]="services" [trackBy]="trackById" class="mat-elevation-z8 ftp-table">

    <ng-container matColumnDef="ftpName">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let s" class="name-cell" [matTooltip]="s.ftpName">{{ s.ftpName }}</td>
    </ng-container>

    <ng-container matColumnDef="ftpServerType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let s"><span class="type-badge">{{ FtpServerTypeUtil.toString(s.ftpServerType) }}</span></td>
    </ng-container>

    <ng-container matColumnDef="ftpServerLocation">
      <th mat-header-cell *matHeaderCellDef>Host</th>
      <td mat-cell *matCellDef="let s" [matTooltip]="s.ftpServerLocation">{{ s.ftpServerLocation }}</td>
    </ng-container>

    <ng-container matColumnDef="controlPort">
      <th mat-header-cell *matHeaderCellDef>Port</th>
      <td mat-cell *matCellDef="let s">{{ s.controlPort }}</td>
    </ng-container>

    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef>Username</th>
      <td mat-cell *matCellDef="let s">{{ s.userName }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let s">
        <span class="status-pill" [class.active]="s.isActive === 1">
          {{ s.isActive === 1 ? 'Active' : 'Inactive' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="connection">
      <th mat-header-cell *matHeaderCellDef>Connection</th>
      <td mat-cell *matCellDef="let s" class="connection-cell" aria-live="polite">
        <ng-container *ngIf="connection[s.id] as c">
          <span class="connection" [ngClass]="c.state" [matTooltip]="c.state === 'connected' || c.state === 'testing' ? '' : c.message">
            <mat-spinner *ngIf="c.state === 'testing'" diameter="14"></mat-spinner>
            <mat-icon *ngIf="c.state === 'connected'">check_circle</mat-icon>
            <mat-icon *ngIf="c.state === 'failed'">cancel</mat-icon>
            <mat-icon *ngIf="c.state === 'not-tested'">help_outline</mat-icon>
            <span>{{ c.state === 'testing' ? 'Testing…' : c.state === 'connected' ? 'Connected' : c.state === 'failed' ? 'Failed' : 'Not tested' }}</span>
          </span>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
      <td mat-cell *matCellDef="let s" class="actions-cell">
        <button mat-icon-button type="button" (click)="editService(s)" [disabled]="deleting.has(s.id)"
                [attr.aria-label]="'Edit ' + s.ftpName" matTooltip="Edit">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="deleteService(s)" [disabled]="deleting.has(s.id)"
                [attr.aria-label]="'Delete ' + s.ftpName" matTooltip="Delete FTP/SFTP Service">
          <mat-icon [ngClass]="deleting.has(s.id) ? 'grey-icon' : 'red-icon'">delete_forever</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
